/**
 * Strip model reasoning/thinking blocks from user-facing LLM text.
 * Keep in sync with mb-server strip-reasoning-content.js patterns.
 */

const THINK = 'think';

export function stripReasoningContent(content: string | null | undefined): string | null {
  if (content == null) return null;
  let cleaned = content;
  const patterns: RegExp[] = [
    /<think>[\s\S]*?<\/redacted_thinking>\s*/gi,
    new RegExp(`<${THINK}>[\\s\\S]*?<\\/${THINK}>\\s*`, 'gi'),
    new RegExp(`<${THINK}>[\\s\\S]*$`, 'gi'),
    /<thinking>[\s\S]*?<\/thinking>\s*/gi,
    /<thinking>[\s\S]*$/gi,
    /<think>[\s\S]*?<\/think>\s*/gi,
    /<think>[\s\S]*$/gi,
  ];
  for (const pattern of patterns) {
    cleaned = cleaned.replace(pattern, '');
  }
  return cleaned.trim();
}
